// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__1ahBA","file":"styles_file__1PesE"};